module.exports = __webpack_public_path__ + "img/opensea.008d1e43.svg";